import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'

import { PreContractStatus, ContractSignStatus } from '../../../constants/enums'

export interface Contract {
  contractPdf?: string
  contractSignStatus?: ContractSignStatus
  preContractPdf?: string
  preContractStatus: PreContractStatus
}

export type ContractState = ImmutableGenericType<Contract>

export const initialState: ContractState = Immutable({
  contractPdf: undefined,
  contractSignStatus: ContractSignStatus.IN_PROGRESS,
  preContractPdf: undefined,
  preContractStatus: PreContractStatus.IN_APPROVAL,
})
